import React from 'react';
import { getTaskFocusSignals } from '../data/taskFocus';

function formatDate(date) {
  if (!date) return 'Sem prazo';
  return new Date(date).toLocaleDateString('pt-BR');
}

function formatDateTime(date) {
  if (!date) return 'Sem data';
  return new Date(date).toLocaleString('pt-BR');
}

function getPriorityClass(priority) {
  return {
    Baixa: 'text-bg-light',
    Media: 'text-bg-info',
    Alta: 'text-bg-warning',
    Urgente: 'text-bg-danger'
  }[priority] || 'text-bg-secondary';
}

export default function TaskCard({ task, onOpen, currentUser, focusPreferences, isFocusTracked = false }) {
  const focus = getTaskFocusSignals(task, currentUser?.id || '', focusPreferences);
  const isMine = focus.isMine;
  const cardClasses = [
    'task-card',
    'shadow-sm',
    focus.overdue ? 'task-card--overdue' : '',
    focus.stalenessLevel ? `task-card--idle-${focus.stalenessLevel}` : '',
    isFocusTracked ? 'task-card--tracked' : ''
  ].filter(Boolean).join(' ');

  return (
    <article className={cardClasses}>
      <div className="d-flex justify-content-between align-items-start gap-3">
        <div>
          <div className="task-title-row">
            <h3>{task.title}</h3>
            {isMine && <span className="badge text-bg-primary">Minha vez</span>}
            {isFocusTracked && <span className="badge text-bg-success">Em foco agora</span>}
            {focus.overdue && <span className="badge text-bg-danger">Prazo vencido</span>}
          </div>
          <div className="task-subtitle">
            {task.customer?.name || 'Cliente não informado'}
          </div>
        </div>
        <span className={`badge ${getPriorityClass(task.priority)}`}>{task.priority}</span>
      </div>

      <div className="task-meta mt-3">
        <span className="badge text-bg-secondary">{task.status}</span>
        <span className="badge text-bg-light">Prazo: {formatDate(task.dueDate)}</span>
        <span className="badge text-bg-light">Resp: {task.assignee?.name || 'Não definido'}</span>
        {focus.stalenessLevel > 0 && (
          <span className={`badge ${focus.stalenessLevel >= 3 ? 'text-bg-danger' : focus.stalenessLevel === 2 ? 'text-bg-warning' : 'text-bg-light'}`}>
            {focus.staleLabel}
          </span>
        )}
        {focus.needsAssignee && <span className="badge text-bg-warning">Sem responsável</span>}
        {!focus.overdue && focus.dueSoon && <span className="badge text-bg-warning">Vence em breve</span>}
        {focus.isUrgent && <span className="badge text-bg-danger">Prioridade crítica</span>}
      </div>

      {task.lastActivity && (
        <div className="task-quick-activity mt-2">
          <strong>Última timeline:</strong> {task.lastActivity.summary} • {formatDateTime(task.lastActivity.at)}
        </div>
      )}

      <div className="task-card-actions mt-3">
        <button type="button" className="btn btn-sm btn-primary" onClick={() => onOpen(task)}>Abrir tarefa</button>
        {!!task.links?.length && (
          <div className="task-card-links">
            {task.links.slice(0, 4).map((link, index) => (
              link.url ? (
                <a
                  key={`${link.source}-${link.id || link.url || index}`}
                  className="task-link-pill"
                  href={link.url}
                  target="_blank"
                  rel="noreferrer"
                  onClick={(event) => event.stopPropagation()}
                >
                  {link.label || link.source}{link.id ? ` #${link.id}` : ''}
                </a>
              ) : (
                <span key={`${link.source}-${link.id || index}`} className="task-link-pill">
                  {link.label || link.source}{link.id ? ` #${link.id}` : ''}
                </span>
              )
            ))}
            {task.links.length > 4 && <span className="task-link-pill">+{task.links.length - 4}</span>}
          </div>
        )}
      </div>
    </article>
  );
}
